<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { blur } from 'svelte/transition';

    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import { filter } from '../../../stores/filter';
    import Separator from '../../shared/Separator.svelte';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import { Account } from './Account';
    import type { AccountApp } from './AccountApp';
    import AccountOne from './AccountOne.svelte';
    import { get } from 'svelte/store';
    import { api } from '../../../stores/api';

    export let addMode: boolean = false;
    export let showFilter: boolean = false;
    export let ap: AccountApp;
    export let account: Account | null = null;

    const compactMode = false;

    // let account: Account | null = null;
    let error: string = '';
    let loading: boolean = true;

    let expandedIndex: string = '';

    let allItems: Account[] = [];
    let filteredItems: Account[] = [];

    async function reloadData(reset: boolean = false) {
        loading = true;
        if (reset) {
            await ap.prepareData(get(api));
        }
        allItems = await ap.getAllItems();
        filteredItems = await ap.getFilteredItems('');
        loading = false;
    }

    onMount(() => {
        reloadData();
    });

    $: {
        ap.getFilteredItems($filter.accounts.query).then(res => {
            filteredItems = res;
        });
    }

    $: {
        ap.getAllItems().then(res => {
            allItems = res;
        });
    }
</script>

{#if loading}
    <Spinner />
{:else if addMode}
    <main style="margin-bottom: 20px;">
        <div data-type="new" style="width: 100%;">
            {#if account}
                <AccountOne
                    {account}
                    bind:ap
                    bind:addMode
                    onAdd={() => {
                        reloadData(true);
                    }}
                />
            {/if}
        </div>
    </main>
{:else if error}
    <MessageDanger {error} />
{:else if allItems.length === 0}
    <MessageNotFound text={$_('no_accounts')} />
{:else}
    <Separator />
    <div class="warehouse-list">
        {#each filteredItems as account, index (account.innerId)}
            <div out:blur>
                <AccountOne showHeader={index === 0} {account} bind:ap bind:expandedIndex />
            </div>
        {:else}
            <div
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 30px;"
            >
                <MessageNotFound text={$_('no_filtered_accounts')} />
            </div>
        {/each}
    </div>
{/if}

<style>
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        /*background-color: var(--section-background);*/
        width: auto;
        height: auto;
        border-radius: 10px;
        padding: 15px;
        row-gap: 3px;
    }
    .warehouse-list {
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
</style>
